module.exports = __webpack_public_path__ + "static/media/startbutton2.f96d6d3c.png";